import { baseApi } from '../apiProvider';
import {
  ResponseCategory,
  ResponseFavoriteCategory,
} from '../models/response/responseCategory';

const categoryAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // get live categories
    getLiveCategoryList: builder.query<Array<ResponseCategory>, void>({
      query: () => ({
        url: '/v0/live-categories',
        method: 'GET',
      }),
    }),
    // get list favorite category
    getListFavoriteCategory: builder.query<
      Array<ResponseFavoriteCategory>,
      void
    >({
      query: () => ({
        url: '/v0/favorite-live-categories',
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetLiveCategoryListQuery, useGetListFavoriteCategoryQuery } =
  categoryAPI;
